// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1723fe2","455":"5572af7b","977":"46c4d76d"}[chunkId] + ".chunk.js";
};